<template>
  <AppContainer :useBackground="true" :useShadow="true">
    <template v-if="isLoading">
      <AppLoading />
    </template>
    <template v-else>
      <div id="cast-profile">
        <div class="cast-profile">
          <card-header
            ref="header"
            :node="headerTitle"
            v-on:blockUser="blockUser()"
          />
          <div id="content-scroll" class="content-scroll" v-if="user">
            <template>
              <div
                class="
                  user-summary
                  text-center
                  d-flex
                  justify-content-center
                  w-100
                "
              >
                <user-summary
                  :propsUser="user"
                  :propsType="typeSingle"
                  :propsScore="isShowScore"
                  @update-like="changeLike"
                  :propsSex="2"
                  v-if="!isShowVideo && !isShowImage"
                />
                <div v-if="isShowVideo" class="position-relative video-player">
                  <video
                    :src="video_url"
                    width="100%"
                    height="100%"
                    class=""
                    id="video"
                    controlslist="nodownload"
                    preload="metadata"
                    type="video/mp4"
                    :poster="image_url_two"
                    @click="playVideo()"
                  ></video>
                  <img
                    src="@/assets/image/icon_profile/icon-play-video.svg"
                    @click="playVideo()"
                    alt=""
                    class="play-video-active position-absolute"
                    v-if="isShowIconPlayVideo"
                  />
                </div>
                <div v-if="isShowImage" class="video-player">
                  <img :src="image_full_url" class="w-100 h-100 image-full" />
                </div>
              </div>
              <div class="image row" v-if="imageDetail">
                <div class="image__div" @click="changeImage(image_url_one, 1)">
                  <img class="image__img img" :src="image_url_one" />
                </div>
                <!-- <div class="image__div" v-if="image_url_two">
              <img
                class="image__img"
                @click="changeImage(image_url_two)"
                :src="image_url_two"
              />
            </div> -->
                <div class="image__div position-relative" v-if="video_url">
                  <video
                    class="image__img"
                    :src="video_url"
                    controlslist="nodownload"
                    preload="metadata"
                    type="video/mp4"
                    :poster="image_url_two"
                    @click="showVideo()"
                  />
                  <img
                    src="@/assets/image/icon_profile/icon-play-video.svg"
                    @click="showVideo()"
                    alt=""
                    class="play-video position-absolute"
                  />
                </div>
                <div
                  class="image__div"
                  v-for="(image, index) in imageDetail"
                  @click="changeImage(image.image_url, 2)"
                  :key="index"
                >
                  <img class="image__img img" :src="image.image_url" />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="name text-left">
                    <p class="f-w3 user-name">ニックネーム</p>
                    <p class="f-w6 nick-name">{{ user.nickname }}</p>
                    <div class="name__div">
                      <span class="name__span f-w3">{{ user.age }}歳</span>
                      <span class="name__span f-w3" v-if="user.height"
                        >{{ user.height }}cm</span
                      >
                      <span class="name__span f-w3">{{ user.occupation }}</span>
                    </div>
                    <div class="user-btn d-flex f-w3">
                      <div
                        class="user-btn-detail user-btn-beautiful"
                        v-if="user.appearance"
                      >
                        {{ user.appearance }}
                      </div>
                      <div
                        class="user-btn-detail user-btn-slender"
                        v-if="user.figure"
                      >
                        {{ user.figure }}
                      </div>
                      <div
                        class="user-btn-detail user-btn-one-member"
                        v-if="user.single_participant == 1"
                      >
                        一人参加OK
                      </div>
                      <div
                        class="user-btn-detail user-btn-english"
                        v-for="(other_preference,
                        index) in user.other_preference"
                        :key="index"
                      >
                        {{ other_preference }}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="rank rank--top">
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">総合ランク</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.overall_rank }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">ゴルフレベル</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.female_golf_rank }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">ランク</p>
                      <span
                        class="rank__span text-right col-6 f-w6"
                        v-if="user.female_prego_rank == 'WHITE'"
                      >
                        プレ友
                      </span>
                      <span
                        class="rank__span text-right col-6 f-w6"
                        v-else-if="user.female_prego_rank == 'BLUE'"
                      >
                        新人
                      </span>
                      <span
                        class="rank__span text-right col-6 f-w6"
                        v-else-if="user.female_prego_rank == 'GREEN'"
                      >
                        通常
                      </span>
                      <span
                        class="rank__span text-right col-6 f-w6"
                        v-else-if="user.female_prego_rank == 'RED'"
                      >
                        超優良
                      </span>
                      <span class="rank__span text-right col-6 f-w6" v-else>
                        {{ user.female_prego_rank }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">
                        30分当たりの料金
                      </p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{
                          Intl.NumberFormat().format(user["30_minutes_pay"])
                        }}P
                      </span>
                    </div>
                  </div> -->
                  <div class="introduce">
                    <p class="introduce__p text-left f-w6">自己紹介</p>
                    <p class="introduce__text f-w3 text-left">
                      {{ user.biography }}
                    </p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="rank rank__right">
                    <p class="title text-left f-w6">基本情報</p>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">
                        ピックアップエリア
                      </p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.prefecture }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left f-w3 col-6">距離</p>
                      <span class="rank__span text-right f-w6 col-6">
                        {{ getDistance() }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">ベストスコア</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.best_score >= 160 ? 160 : user.best_score }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">アベレージ</p>
                      <span class="rank__span text-right col-6 f-w6">{{
                        user.avg_score >= 180 ? 180 : user.avg_score
                      }}</span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">ゴルフ歴</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.golf_experience }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">
                        年間ゴルフラウンド数
                      </p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.golf_frequency }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">プレーエリア</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.area }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">合流方法</p>
                      <span
                        class="rank__span text-right col-6 f-w6"
                        v-if="user.meeting_method"
                      >
                        {{ user.meeting_method }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">交際</p>
                      <span class="rank__span text-right col-6 f-w6">
                        {{ user.relationship }}
                      </span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">タバコ</p>
                      <span class="rank__span text-right col-6 f-w6">{{
                        user.cigarette
                      }}</span>
                    </div>
                    <div class="rank__div row align-items-center">
                      <p class="rank__p text-left col-6 f-w3">お酒</p>
                      <span class="rank__span text-right col-6 f-w6">{{
                        user.alcohol
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="divide" v-if="user.round_logs.length > 0" />
              <div class="diary" v-if="user.round_logs.length > 0">
                <div
                  class="
                    d-flex
                    diary-text
                    justify-content-between
                    align-items-center
                  "
                >
                  <p class="text-left diary-text__title f-w6 mb-0">
                    ラウンドログ
                  </p>
                  <div
                    class="d-flex align-items-center"
                    style="cursor: pointer"
                    @click="
                      $router.push({
                        name: 'MenRoundLogList',
                        query: {
                          user_id: user.user_id,
                          sex: 2
                        }
                      })
                    "
                  >
                    <!-- <p class="diary-text-more mb-0">もっと見る</p> -->
                    <b-icon icon="chevron-right" />
                  </div>
                </div>
                <div class="row diary__div--row">
                  <div
                    class="diary__div col-lg-6"
                    v-for="(roundlog, index) in user.round_logs"
                    :key="index"
                  >
                    <div class="heading d-flex justify-content-between">
                      <div class="heading__div">
                        <p class="heading__p" />
                        <p class="heading__span f-w6 mb-0">
                          {{ roundlog.nickname }}
                        </p>
                      </div>
                      <div
                        class="d-flex justify-content-end aligin-items-center"
                      >
                        <div
                          class="
                            heading__div heading__p--left
                            d-flex
                            flex-column
                            justify-content-center
                          "
                        >
                          <p class="f-w3 heading__p">ラウンドスコア</p>
                          <span class="heading__span f-w6">{{
                            roundlog.score
                          }}</span>
                        </div>
                        <div
                          class="
                            heading__div
                            d-flex
                            flex-column
                            justify-content-center
                          "
                        >
                          <p class="f-w3 heading__p">満足度</p>
                          <span class="heading__span f-w6">{{
                            roundlog.evaluation
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="diary__div-text">
                      <p class="f-w3 text-left diary__div-text__p">
                        {{
                          (index == 0 && !isShowFullText) ||
                          (index == 1 && !isShowFullTextBottom)
                            ? compactText(roundlog.comment)
                            : roundlog.comment
                        }}
                        <span
                          v-if="
                            ((index == 0 && !isShowFullText) ||
                              (index == 1 && !isShowFullTextBottom)) &&
                              roundlog.comment.length > getNumberCharacters()
                          "
                          class="show-text f-w3"
                          @click="showFullText(index)"
                          style="cursor: pointer"
                        >
                          詳細
                        </span>
                      </p>
                      <p
                        v-if="
                          !(
                            (index == 0 && !isShowFullText) ||
                            (index == 1 && !isShowFullTextBottom)
                          )
                        "
                        class="text-left show-text show-text-full f-w3"
                        @click="showFullText(index)"
                        style="cursor: pointer"
                      >
                        たたむ
                      </p>
                    </div>
                    <div
                      class="divide--small survey"
                      v-if="index < user.round_logs.length - 1"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="divide" v-if="usersSimilar.length > 0" />
              <div class="similar" v-if="usersSimilar.length > 0">
                <p class="title text-left f-w6">似ているゴルファー</p>
                <div class="d-flex overflow-auto">
                  <user-summary
                    @getUser="getUser()"
                    v-for="(user, index) in usersSimilar"
                    :key="index"
                    :propsUser="user"
                    :propsType="typeScrollProfile"
                    :propsSex="2"
                    @update-like="changeLikeStatusUserSimilar"
                  />
                </div>
              </div>
              <div
                class="divide"
                v-if="firebaseProfileTweets && firebaseProfileTweets.length > 0"
              />
              <div
                class="diary"
                style="padding-bottom: 0"
                v-if="
                  firebaseProfileTweets &&
                    firebaseProfileTweets.length > 0 &&
                    headerTitle.iconDot
                "
              >
                <div
                  class="
                    d-flex
                    diary-text
                    justify-content-between
                    align-items-center
                    mb-0
                  "
                >
                  <p class="text-left diary-text__title f-w6 mb-0">つぶやき</p>
                  <div
                    class="d-flex align-items-center"
                    style="cursor: pointer"
                    @click="
                      $router.push({
                        name: 'MenTimeLineList',
                        query: {
                          userId: $route.params.id
                        }
                      })
                    "
                  >
                    <!-- <p class="diary-text-more mb-0">もっと見る</p> -->
                    <b-icon icon="chevron-right" />
                  </div>
                </div>
              </div>
              <div
                class="vol"
                v-if="
                  firebaseProfileTweets &&
                    firebaseProfileTweets.length > 0 &&
                    headerTitle.iconDot
                "
              >
                <!-- <p class="title text-left f-w6">つぶやき</p> -->
                <TimelineListProfile
                  :propsAvatar="user.image_url"
                  :propsNickname="user.nickname"
                  :propsTimeline="firebaseProfileTweets"
                  :propsIdAuth="me.user_id"
                  @like="like"
                />
              </div>
            </template>
          </div>
          <card-footer ref="footer" prefer="home" />
        </div>
        <div class="d-flex justify-content-center" v-if="headerTitle.iconDot">
          <div class="blur-filter"></div>
        </div>
        <div class="footer-btn f-w6" v-if="headerTitle.iconDot">
          <button
            class="
              button-submit
              d-flex
              justify-content-center
              align-items-center
            "
            type="submit"
            v-if="monthlyPlanStatus"
            @click="showModal()"
          >
            <transition name="slide-up">
              <div class="offer-option position-absolute" v-if="isShowOption">
                <div
                  class="
                    offer-option__div
                    d-flex
                    justify-content-start
                    align-items-center
                  "
                  @click="showModalOffer(2)"
                  :class="isShowOrder ? '' : 'active'"
                >
                  <img
                    src="@/assets/image/icon_profile/golf-course.svg"
                    alt=""
                  />
                  日付とゴルフ場を決めてからオファーする
                </div>
                <!--                <hr v-if="isShowOrder" />-->
                <!--                <div-->
                <!--                  class="-->
                <!--                    offer-option__div-->
                <!--                    d-flex-->
                <!--                    justify-content-start-->
                <!--                    align-items-center-->
                <!--                  "-->
                <!--                  @click="showModalOffer(1)"-->
                <!--                  v-if="isShowOrder"-->
                <!--                >-->
                <!--                  <img-->
                <!--                    src="@/assets/image/icon_profile/icon-profile.svg"-->
                <!--                    alt=""-->
                <!--                  />-->
                <!--                  募集しているラウンドにオファーする-->
                <!--                </div>-->
              </div>
            </transition>
            <img src="@/assets/image/serve-button.svg" alt="" />Superオファー
          </button>
          <button
            class="
              button-submit
              d-flex
              justify-content-center
              align-items-center
            "
            type="submit"
            @click="checkIdentify()"
          >
            <img
              src="@/assets/image/icon_profile/messenger.svg"
              alt=""
            />メッセージを送る
          </button>
          <!-- <div class="blur-filter" /> -->
        </div>
        <ModalProflie
          ref="myModal"
          id="view-cast-profile__popup"
          @showOption="showOption()"
          :propsModal="!isShowOrder"
        >
          <div class="view-cast-profile__popup-bottom f-w3 text-center">
            <div
              class="
                view-cast-profile__popup-bottom__div
                d-flex
                justify-content-start
                align-items-center
              "
              @click="showModalOffer(2)"
              :class="isShowOrder ? '' : 'active'"
            >
              <img src="@/assets/image/icon_profile/golf-course.svg" alt="" />
              日付とゴルフ場を決めてからオファーする
            </div>
            <!--            <hr v-if="isShowOrder" />-->
            <!--            <div-->
            <!--              class="-->
            <!--                view-cast-profile__popup-bottom__div-->
            <!--                d-flex-->
            <!--                justify-content-start-->
            <!--                align-items-center-->
            <!--              "-->
            <!--              @click="showModalOffer(1)"-->
            <!--              v-if="isShowOrder"-->
            <!--            >-->
            <!--              <img src="@/assets/image/icon_profile/icon-profile.svg" alt="" />-->
            <!--              募集しているラウンドにオファーする-->
            <!--            </div>-->
          </div>
        </ModalProflie>
        <ModalLayout ref="modal-offer-cast">
          <!--          <p class="modal-logout-title f-w3 mt-3 mb-0">-->
          <!--            オファーをする場合は通常料金とは別に-->
          <!--          </p>-->

          <!--          <p class="modal-logout-title f-w3">10,000ポイント消費されます</p>-->

          <div class="title-more">
            <!--            <p class="modal-logout-title f-w3 mt-3 mb-0">-->
            <!--              こちらの女性とラウンドに行ける可能性が高くなりますが-->
            <!--            </p>-->
            <!--            <p class="modal-logout-title f-w3 mb-0">-->
            <!--              ラウンド成立時には10,000ポイントが消費されます。-->
            <!--            </p>-->
            <br />
            <p class="modal-logout-title f-w6 mb-0">
              Super オファーとは
            </p>
            <p class="modal-logout-title-other f-w3 mb-0">
              お相手への「ポイント付与」を約束することで
            </p>
            <p class="modal-logout-title-other f-w3 mb-0">
              来てくれる確率を上げることができるダイレクトオファーになります。
            </p>
            <p class="modal-logout-title-other f-w3 mb-0">
              ✔マッチングが成立しなければポイントは消費されません。
            </p>
            <p class="modal-logout-title-other f-w3">
              ✔あなたの都合の良い日にお相手をオファーできます。
            </p>
          </div>

          <div class="d-flex justify-content-center">
            <button @click.prevent="closeModel(type)" class="btn-logout">
              はい
            </button>
            <button @click="cancelOffer" class="btn-cancel-logout">
              いいえ
            </button>
          </div>
        </ModalLayout>
        <ModalLayout ref="creditPopup" :defaultStyle="false">
          <createOrderPopup @closeModal="$refs.creditPopup.closeModal()" />
        </ModalLayout>
        <ModalLayout ref="creditIdentifyPopup" :defaultStyle="false">
          <IdentifyCrefitCardPopup
            @closeModal="$refs.creditIdentifyPopup.closeModal()"
          />
        </ModalLayout>
        <ModalLayout ref="identifyPopup" :defaultStyle="false">
          <IdentifyPopup
            @identify="identify"
            :identity_status="me.identity_status"
            :sex="2"
          />
        </ModalLayout>
      </div>
    </template>
  </AppContainer>
</template>

<script>
import UserSummary from "@/components/UserSummary.vue";
import CardFooter from "@/components/CardFooter.vue";
import CardHeader from "@/components/CardHeader.vue";
import ModalProflie from "@/views/Common/ModalProfile.vue";
import service from "@/utils/axios";
import { USER_URL } from "@/api/api";
import { appearance, figure } from "@/constants/req";
import { mapGetters, mapActions } from "vuex";
import createOrderPopup from "@/components/CreateOrderPopup.vue";
import IdentifyCrefitCardPopup from "@/components/IdentifyCrefitCardPopup.vue";
import IdentifyPopup from "@/components/IdentifyPopup.vue";
import { INDIVIDUAL_ROOM_TYPE } from "@/constants/message";
import TimelineListProfile from "@/views/Common/Timeline/TimelineListProfile.vue";

export default {
  name: "CastProfile",
  metaInfo() {
    return {
      title: "プロフィール",
      titleTemplate: "%s | Prego"
    };
  },
  components: {
    "user-summary": UserSummary,
    "card-footer": CardFooter,
    "card-header": CardHeader,
    ModalProflie,
    createOrderPopup,
    IdentifyCrefitCardPopup,
    IdentifyPopup,
    TimelineListProfile
  },

  data() {
    return {
      isShowScore: true,
      headerTitle: {
        text: "プロフィール",
        isShowTitle: true,
        isShowLogo: false,
        iconDot: true
      },
      type: null,
      isShowOrder: true,
      imageDetail: [],
      showOptionBlock: true,
      isShowOption: false,
      appearanceOption: appearance,
      figureOption: figure,
      text:
        "今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました- 今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました- 今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました-",
      textBottom:
        "今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました- 今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました- 今日のラウワンドはすごく気拘ちがよく、楽しい計間になりました-",
      textBottomCompact: "",
      textCompact: "",
      isShowFullText: false,
      usersSimilar: null,
      isShowFullTextBottom: false,
      user: null,
      typeSingle: { type: "single" },
      typeScrollProfile: { type: "scroll-profile" },
      video_url: null,
      isShowVideo: false,
      isShowIconPlayVideo: true,
      image_url_two: null,
      image_url_one: null,
      isShowImage: false,
      image_full_url: null,
      listTimeLine: [
        {
          image: [
            { image_url: null },
            { image_url: null },
            { image_url: null }
          ],
          content:
            "ブログの本文、ブログの本文 ブログの本文、ブログの本文 ブログの本文、ブログの本文",
          id: 1
        },
        {
          image: [
            { image_url: null },
            { image_url: null },
            { image_url: null }
          ],
          content:
            "ブログの本文、ブログの本文 ブログの本文、ブログの本文 ブログの本文、ブログの本文",
          id: 2
        },
        {
          image: [
            { image_url: null },
            { image_url: null },
            { image_url: null }
          ],
          content:
            "ブログの本文、ブログの本文 ブログの本文、ブログの本文 ブログの本文、ブログの本文",
          id: 3
        },
        {
          image: [
            { image_url: null },
            { image_url: null },
            { image_url: null }
          ],
          content:
            "ブログの本文、ブログの本文 ブログの本文、ブログの本文 ブログの本文、ブログの本文",
          id: 4
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "common/isLoading",
      me: "auth/user",
      cardInfo: "payment-stripe/cardInfo",
      limit: "areaLimit/limit_area",
      firebaseProfileTweets: "firebase/profileTweets",
      monthlyPlanStatus: "payment-stripe/monthlyPlanStatus"
    })
  },
  async created() {
    this.$store.dispatch("common/setIsLoading", true);
    let id = this.$route.params.id;
    // console.log(id);
    await this.getInfoUser(id);
    await this.getListOrder();
    await this.getProfileTweets({ userId: id });
    await this.getPaymentMonthPacket();
    this.$store.dispatch("common/setIsLoading", false);
  },
  mounted() {
    if (document.getElementById("cast-profile")) {
      document.getElementById("cast-profile").scrollIntoView();
    }
  },
  methods: {
    ...mapActions("firebase", ["createRoom", "getProfileTweets", "likeTweet"]),
    ...mapActions("payment-stripe", ["getPaymentMonthPacket"]),

    async like(e) {
      let action = "like";
      if (e.is_like) {
        action = "unlike";
      }
      this.likeTweet({
        userId: this.me.user_id,
        tweetId: e.id,
        action: action
      });
      await this.getProfileTweets({ userId: this.$route.params.id });
    },

    getDistance() {
      if (this.me.lat && this.user.lat) {
        const distance = this.distance(
          this.user.lat,
          this.user.long,
          this.me.lat,
          this.me.long
        );
        if (distance < 5) {
          return "5.0km以内";
        } else if (distance > 100) {
          return "100km以上";
        } else if (distance <= 10) {
          return Math.ceil(distance) + ".0km";
        } else {
          return Math.ceil(distance / 5) * 5 + ".0km";
        }
      }
    },

    distance(lat1, lon1, lat2, lon2) {
      let p = 0.017453292519943295; // Math.PI / 180
      let c = Math.cos;
      let a =
        0.5 -
        c((lat2 - lat1) * p) / 2 +
        (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
      return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
    },

    checkIdentify() {
      this.createRoom();
    },
    showFullText(index) {
      if (index == 0) {
        this.isShowFullText = !this.isShowFullText;
        return;
      }

      this.isShowFullTextBottom = !this.isShowFullTextBottom;
    },
    compactText(text) {
      let textStr = String(text);
      if (text.length > this.getNumberCharacters()) {
        return textStr.substr(0, this.getNumberCharacters()) + "...";
      }

      return textStr;
    },
    getNumberCharacters() {
      let characters = 0;
      if (window.innerWidth < 992)
        characters = Math.floor(43 + (window.innerWidth - 375) / 8);
      else characters = Math.floor(330 / 8);
      return characters;
    },
    showModalOffer(type) {
      this.type = type;
      this.$refs["modal-offer-cast"].openModal();
    },
    getListOrder() {
      this.$store
        .dispatch("orderManagement/getOrderList", {
          page: 1,
          user_id: this.me.user_id
        })
        .then(response => {
          if (response.data.total == 0) {
            this.isShowOrder = false;
          }
        })
        .catch(() => {});
    },
    changeLike(data) {
      service({
        url: USER_URL + "/favorite",
        method: "POST",
        data: {
          user_id: data.userId,
          is_favorite: data.isFavorite === 1 ? 0 : 1
        }
      }).then(response => {
        if (response.data.success === true) {
          this.user.is_favorite = data.isFavorite === 1 ? 0 : 1;
        }
      });
    },
    changeLikeStatusUserSimilar(data) {
      service({
        url: USER_URL + "/favorite",
        method: "POST",
        data: {
          user_id: data.userId,
          is_favorite: data.isFavorite === 1 ? 0 : 1
        }
      }).then(response => {
        const item = this.usersSimilar.find(
          item => item.user_id === data.userId
        );
        if (response.data.success === true) {
          item.is_favorite = data.isFavorite === 1 ? 0 : 1;
        }
      });
    },
    formatTextArea(text) {
      let textArea = "";
      if (text.length >= 2) {
        for (let i = 0; i < text.length; i++) {
          if (i == text.length - 1) {
            textArea += text[i];
          } else {
            textArea += text[i] + "、";
          }
        }
      } else {
        textArea += text[0];
      }
      return textArea;
    },
    formatText(text) {
      for (let i = 0; i <= text.length; i++) {
        if (text[i] == "~") {
          const text_format =
            text.substr(0, i) +
            "回" +
            " ~ " +
            text.substr(i + 1, text.length) +
            "回";
          return text_format;
        }
      }
    },
    showModal() {
      if (this.limit > 0) {
        return;
      }
      this.$refs["myModal"].openModal();
      this.isShowOption = !this.isShowOption;
    },
    showOption() {
      this.showOptionBlock = true;
    },
    async getInfoUser(id) {
      await this.$store.dispatch("userApp/getInfoUser", id);
      this.user = this.$store.getters["userApp/user"].user;
      if (this.$store.getters["userApp/user"].isBlock) {
        this.headerTitle.iconDot = false;
      }
      this.user.area = null;
      if (this.user.user_golf_areas.length > 0) {
        this.user.area = this.formatTextArea(this.user.user_golf_areas);
      }
      this.imageDetail = [];
      if (this.user.sex == 2) {
        for (let i = 0; i < this.user.image_urls.length; i++) {
          if (this.user.image_urls[i].type == 1) {
            if (this.user.image_urls[i].display_order == 1) {
              this.user.image_url = this.user.image_urls[i].image_url;
              this.image_url_one = this.user.image_urls[i].image_url;
              this.$store.state.userApp.image_url = this.user.image_url;
            } else if (this.user.image_urls[i].display_order == 2) {
              this.image_url_two = this.user.image_urls[i].image_url;
            } else {
              this.imageDetail.push(this.user.image_urls[i]);
            }
          }
          if (this.user.image_urls[i].type == 3) {
            this.video_url = this.user.image_urls[i].image_url;
          }
        }
        this.usersSimilar = this.user.similar_users;
      } else {
        this.$router.push({ name: "403" });
      }
      if (this.user.golf_frequency != null) {
        this.user.golf_frequency = this.formatText(this.user.golf_frequency);
      }
    },
    changeImage(image_url, type) {
      this.isShowVideo = false;
      this.isShowImage = false;
      this.user.image_url = image_url;
      this.$store.state.userApp.image_url = image_url;
      this.isShowIconPlayVideo = true;
      if (type == 1) {
        this.isShowScore = true;
        return;
      }
      this.isShowScore = false;
    },
    changeFullImage(url) {
      this.isShowImage = true;
      this.isShowVideo = false;
      this.image_full_url = url;
      this.isShowIconPlayVideo = true;
    },
    showVideo() {
      this.isShowVideo = true;
      this.isShowImage = false;
      if (!this.isShowIconPlayVideo) {
        this.isShowIconPlayVideo = true;
      }
    },
    playVideo() {
      const video = document.getElementById("video");
      if (video.paused || video.ended) {
        video.play();
        this.isShowIconPlayVideo = false;
      } else {
        video.pause();
        this.isShowIconPlayVideo = true;
      }
    },
    async getUser() {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    cancelOffer() {
      this.$refs["modal-offer-cast"].closeModal();
    },
    closeModel(type) {
      if (this.me.identity_status == 3 && this.cardInfo == null && type === 1) {
        this.$refs["creditPopup"].openModal();
      } else if (
        this.me.identity_status != 3 &&
        this.cardInfo == null &&
        type === 1
      ) {
        this.$refs.creditIdentifyPopup.openModal();
      } else if (
        this.me.identity_status != 3 &&
        this.cardInfo != null &&
        type === 1
      ) {
        this.$refs.identifyPopup.openModal();
      } else {
        if (type === 1) {
          this.$router.push({
            name: "MenOrderList",
            query: { profileId: this.$route.params.id }
          });
          return;
        }
        this.$router.push({
          name: "MenCreateOrderDirectStepOne",
          params: { profileId: this.$route.params.id },
          query: {
            prefecture: this.user.prefecture,
            offer: "true"
          }
        });
      }
    },
    identify() {
      if (this.$route.name != "MenMyPageIdentifyProfile")
        this.$router.push({ name: "MenMyPageIdentifyProfile" });
      this.$refs.identifyPopup.closeModal();
      return;
    },
    cancelCredit() {
      this.$refs.creditPopup.closeModal();
    },
    async blockUser() {
      this.$root.$refs.loading.start();
      // for block
      let data = { user_block_id: this.$route.params.id };
      let msg = "ブロックしました。";

      await service({
        url: USER_URL + "/block",
        method: "POST",
        data
      })
        .then(() => {
          this.$toast(msg, "通知", "success");
          this.headerTitle.iconDot = false;
          this.$root.$refs.loading.finish();
        })
        .catch(() => {
          this.$root.$refs.loading.finish();
        });
    },
    async createRoom() {
      this.$root.$refs.loading.start();
      let data = {
        hiddenUserIds: {
          [this.me.user_id]: true,
          [this.$route.params.id]: true
        },
        userIds: [this.me.user_id, this.$route.params.id],
        adId: null,
        type: INDIVIDUAL_ROOM_TYPE
      };
      await this.$store
        .dispatch("firebase/createRoom", data)
        .then(result => {
          this.$router.push({ name: "MessageDetail", params: { id: result } });
        })
        .catch(error => {
          throw error;
        });
      this.$root.$refs.loading.finish();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/men/castProfile.scss";
@import "@/assets/scss/_fontFamily.scss";

.content-scroll {
  // overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 60px;
  padding-bottom: 150px;
  // height: calc(100vh - 108px);
}

@media screen and (min-width: 1200px) {
  .content-scroll {
    // height: calc(100vh - 152px);
    padding-bottom: 250px;
    padding-top: 80px;
  }
}

.slide-up {
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  &-enter-active,
  &-leave-active {
    transition: ease 0.5s;
  }

  &-enter-to,
  &-leave {
    opacity: 1;
    transform: translateY(0);
  }
}

.title-more {
  text-align: left;
}

.modal-logout-title-other {
  font-size: 11px;
}
</style>
